import $ from 'jquery'

$('.scroll-down').on('click', function () {
  $('html, body').animate(
    {
      scrollTop: $('#scroll-down-destination').offset().top,
    },
    100
  )
})

$('.simple-header__img--icon').on('click', function () {
  $('html, body').animate(
    {
      scrollTop: $('#end-simple-header').offset().top,
    },
    100
  )
})
